import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import vehiclesData from "../../data/vehiclesData";
import VehicleListCard from "../../components/cards/VehicleListCard/VehicleListCard";
import "./VehiclesPage.css";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import { useTranslation } from "react-i18next";

export default function VehiclesPage() {
  const { t } = useTranslation();

  return (
    <div className="vehiclesPage">
      <div className="vehiclesPageBanner text-center">
        <div className="page-banner-content">
          <h3>{t("vehiclesPage.bannerSubtitle")}</h3>
          <h1>{t("vehiclesPage.bannerTitle")}</h1>
        </div>
      </div>

      <Container fluid>
        <div className="section-spacing">
          <p className="brand-section-desc text-center mb-0">
            {t("vehiclesPage.taglineOne")}
          </p>
          <p className="brand-section-desc text-center mb-0">
            {t("vehiclesPage.taglineTwo")}
          </p>
        </div>

        <Row className="gy-4">
          {vehiclesData.map((vehicle) => (
            <Col key={vehicle.id} md={12} lg={6}>
              <VehicleListCard vehicle={vehicle} />
            </Col>
          ))}
        </Row>
      </Container>

      <div className="section-spacing-top">
        <AftersalesSupportSection />
      </div>
    </div>
  );
}